// Classes
import { CartItem } from "./CartItem";

export class CartTrackingData {
	event: "add_to_cart";
	ecommerce: {
		items: CartItem[];
	};
	constructor(ecommerce: { items: CartItem[] }) {
		this.event = "add_to_cart";
		this.ecommerce = ecommerce;
	}
}
